import React from 'react';

import VerticalLayoutView from './vertical-layout.view';

export default function VerticalLayout(props) {
    return <VerticalLayoutView {...props} />;
}
